import { Loader } from './Loader';
import extension from '../url/extension';
/**
 * A {@link Loader} that loads images from urls
 * @extends Loader
 * @category loader
 * @author Geoffrey Mayeux
 */
class ImageLoader extends Loader{
	constructor(){
		super();

		this.ajax = false;
	}

	accepts(item){
		return typeof item == "string";
	}

	async loadItem(item){
		if(this.ajax)
			return await this.loadAjax(item);
		return await this.loadSimple(item);
	}

	loadSimple(item){
		return new Promise((resolve, reject) => {
			let temp = item;
			let img = new window.Image();
				img.onload = () => resolve(img);
				img.crossOrigin = "Anonymous";
				img.onerror = () => {
					reject(new Error(`Could not load '${item}'`));
				}
				img.src = temp;
		});
	}

	loadAjax(item){
		return new Promise((resolve, reject) => {
			let temp = item;

			let img = new window.Image();
		    let req = new XMLHttpRequest();

		    
		    req.open( 'GET', temp , true );
		    req.responseType = 'arraybuffer';

		    req.onerror = e => reject(e);

		    req.onload = function( e ) {
		        var h = req.getAllResponseHeaders(),
		            m = h.match( /^Content-Type\:\s*(.*?)$/mi ),
		            mimeType = m[ 1 ] || 'image/png';

		        var blob = new Blob( [ req.response ], { type: mimeType } );
		        img.src = window.URL.createObjectURL( blob );
		        resolve();
		    };

		    req.onprogress = e => {
		        if ( e.lengthComputable ){
		            this.progresses.set(temp, e.loaded / e.total);
		            this.triggerProgress();
		        }
		    };

		    req.onloadend = () => {
		        this.progresses.set(temp, 1);
		        this.triggerProgress();
		    }

		    req.send();
		});
	}

}

export default ImageLoader;
export { ImageLoader };